import { render, staticRenderFns } from "./UpdateContact.vue?vue&type=template&id=249bae62"
import script from "./UpdateContact.vue?vue&type=script&lang=js"
export * from "./UpdateContact.vue?vue&type=script&lang=js"
import style0 from "./UpdateContact.vue?vue&type=style&index=0&id=249bae62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports